import { useEffect } from 'react';

import { useAuthStore } from '@/stores/useAuthStore';
import Intercom from '@intercom/messenger-js-sdk';

const INTERCOM_APP_ID = String(import.meta.env.VITE_INTERCOM_APP_ID ?? '');

export const IntercomProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const user = useAuthStore((state) => state.user);

  useEffect(() => {
    if (INTERCOM_APP_ID === '' || user === null) {
      return;
    }

    Intercom({
      app_id: INTERCOM_APP_ID,
      user_id: user.Id,
      name: user.Name,
      email: user.Email
    });
  }, [user]);

  return <>{children}</>;
};
